import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: 'var(--bg-card)' }} className="border-t" style={{ borderColor: 'var(--border-medium)' }}>
      <div className="container max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 py-16">
          {/* Company Info */}
          <div className="fade-in">
            <h3 className="heading-4 mb-5" style={{ color: 'var(--text-primary)' }}>AddVantage</h3>
            <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
              Advertising that brings profit. We create strategies tailored to your business with transparent reporting and results-driven approach.
            </p>
            <div className="flex space-x-4">
              <a 
                href="mailto:ilona.j@addvantage.team" 
                className="transition-transform hover:scale-110"
                aria-label="Send Email"
              >
                <Mail className="h-5 w-5" style={{ color: 'var(--brand-primary)' }} />
              </a>
              <a 
                href="https://t.me/addvantageteam" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-transform hover:scale-110"
                aria-label="Contact on Telegram"
              >
                <Phone className="h-5 w-5" style={{ color: 'var(--brand-primary)' }} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="fade-in fade-in-delay-1">
            <h3 className="heading-4 mb-5" style={{ color: 'var(--text-primary)' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="body-medium hover:text-brand-primary transition-colors" style={{ color: 'var(--text-secondary)' }}>
                  Home
                </a>
              </li>
              <li>
                <a href="/services" className="body-medium hover:text-brand-primary transition-colors" style={{ color: 'var(--text-secondary)' }}>
                  Our Services
                </a>
              </li>
              <li>
                <a href="/faq" className="body-medium hover:text-brand-primary transition-colors" style={{ color: 'var(--text-secondary)' }}>
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="fade-in fade-in-delay-2">
            <h3 className="heading-4 mb-5" style={{ color: 'var(--text-primary)' }}>Services</h3>
            <ul className="space-y-2">
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>Telegram Advertising</li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>Instagram Marketing</li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>Media Planning</li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>Content Marketing</li>
              <li className="body-medium" style={{ color: 'var(--text-secondary)' }}>Analytics & Reporting</li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t py-8" style={{ borderColor: 'var(--border-medium)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="body-small" style={{ color: 'var(--text-muted)' }}>
              © 2024 AddVantage. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="body-small hover:text-brand-primary transition-colors" style={{ color: 'var(--text-muted)' }}>
                Privacy Policy
              </a>
              <a href="#" className="body-small hover:text-brand-primary transition-colors" style={{ color: 'var(--text-muted)' }}>
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;